<template>
<!-- the dashboard has to consist of the following
  create product
  view products
  modify products stock etc
  table of orders
  view orders by product
-->
<div>
  <Nav />
  <div id="homepage">
    <b-container>
      <!-- <ProductModal/> -->

      <Products />
      <OrderTable />

    </b-container>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Nav from '@/components/Nav'
import OrderTable from '@/components/OrderTable'
import ProductModal from '@/components/ProductModal'
import Products from '@/components/Products'

export default {
  name: 'home',
  components: {
    HelloWorld,
    Nav,
    OrderTable,
    ProductModal,
    Products
  },
  methods: {},
  created() {
    this.$store.dispatch('auth/fetchUser')
    this.$store.dispatch('orders/getOrders')
    this.$store.dispatch('products/getProducts')
  }
}
</script>
<style lang="stylus">
#homepage
  padding: 30px
  </style>
